import React, { useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import LogoGym from "../../Picture/logoKekes.png";
import LogoSilang from "../../Picture/logoSilang.png";
import { useNavigate } from "react-router-dom";
import Gambar1 from "../../Picture/gambarGym1.png";
import Gambar2 from "../../Picture/gambarGym2.png";
import Gambar3 from "../../Picture/gambarGym3.jpg";
import Gambar4 from "../../Picture/gambarGym4.jpg";
import Gambar5 from "../../Picture/gambarGym5.jpg";
import Gambar6 from "../../Picture/gambarGym6.png";

const AttendanceGym2 = (props) => {
  const [scanRfid, setScanRfid] = useState("");
  const [autoFocusActive, setAutoFocusActive] = useState(true);
  const [valuePembayaranFreelance, setValuePembayaranFreelance] = useState("");
  const [
    visibleKeteranganPembayaranFreelance,
    setVisibleKeteranganPembayaranFreelance,
  ] = useState(false);
  const [containerPembayaranFreelance, setContainerPembayaranFreelance] =
    useState(false);
  const [berhasilFreelance, setBerhasilFreelance] = useState(false);
  const images = [Gambar1, Gambar2, Gambar3, Gambar4, Gambar5, Gambar6];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [namaSapaan, setNamaSapaan] = useState("");
  const today = new Date().toISOString().split("T")[0];

  const navigate = useNavigate("");
  const inputRef = useRef(null);
  const url = props.url;
  // fucntion setelah scan rfid
  const ScanRfid = (value) => {
    setScanRfid(value);

    if (value.length === 10) {
      fetch(url + "/?op=getRfidFreelance", {
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: "rfid=" + value,
      })
        .then((response) => response.json())
        .then((json) => {
          if (json === "freelance") {
            setAutoFocusActive(false);
            setContainerPembayaranFreelance(true);
          } else {
            fetch(url + "/?op=getNamaScan2", {
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              body: "rfid=" + value + "&date=" + today,
            })
              .then((response) => response.json())
              .then((json) => {
                if (json[0] !== "expired") {
                  if (json === "data tidak ditemukan") {
                    localStorage.setItem("rfid", value);
                    navigate("/gym2/attendance/memberBaru");
                  } else {
                    setBerhasilFreelance(true);
                    setNamaSapaan(json);

                    setScanRfid("");
                    setAutoFocusActive(true);

                    setTimeout(() => {
                      setBerhasilFreelance(false);
                    }, 3000);
                  }
                } else {
                  localStorage.setItem("data", JSON.stringify(json));
                  navigate("/gym2/attendance/memberPerpanjangan");
                }
              });
          }
        });
    }
  };
  // function klik silang pembayran freelance
  const KlikSilangPembayaranFreelance = () => {
    setScanRfid("");
    setAutoFocusActive(true);
    setContainerPembayaranFreelance(false);
  };
  // fucntion klik kirim pembayaran freelance
  const KlikKirimPembayaranFreelance = () => {
    if (
      valuePembayaranFreelance === "Pilih" ||
      valuePembayaranFreelance === ""
    ) {
      setVisibleKeteranganPembayaranFreelance(true);
    } else {
      setVisibleKeteranganPembayaranFreelance(false);
      fetch(url + "/?op=inputFreelance2", {
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: "rfid=" + scanRfid + "&pembayaran=" + valuePembayaranFreelance,
      })
        .then((response) => response.json())
        .then((json) => {
          if (json === "Freelance visitor") {
            setBerhasilFreelance(true);
            setNamaSapaan(json);
            setContainerPembayaranFreelance(false);
            setScanRfid("");
            setAutoFocusActive(true);

            setTimeout(() => {
              setBerhasilFreelance(false);
            }, 3000);
          }
        });
    }
  };
  // ganti gambar
  useEffect(() => {
    const interval = setInterval(() => {
      // ganti index ke gambar berikutnya
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // 5 detik

    return () => clearInterval(interval); // bersihkan interval saat unmount
  }, [images.length]);

  // fokus pertama kali
  useEffect(() => {
    if (autoFocusActive && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocusActive]);
  //
  useEffect(() => {
    if (!autoFocusActive || !inputRef.current) return;

    const handleBlur = () => {
      if (autoFocusActive && inputRef.current) {
        inputRef.current.focus();
      }
    };

    const el = inputRef.current;
    el.addEventListener("blur", handleBlur);

    return () => {
      el.removeEventListener("blur", handleBlur);
    };
  }, [autoFocusActive]);
  // use effect cek session
  useEffect(()=>{
      fetch(url + "/?op=cekSession", {
          credentials: "include", 
        })
        .then((response)=>response.json())
        .then((json)=>{
         
        if (json === "kosong") {
              navigate("/", { replace: true });
            }else if(json ==="gym1"){
  navigate("/gym1", { replace: true });
            }else if(json ==="owner"){
  navigate("/owner", { replace: true });
            }
        })
      },[])
  return (
    <div className={style.containerAll}>
      <div className={style.divGambar}>
        <img src={images[currentIndex]} alt="slideshow" />
      </div>
      <div
        style={{ display: containerPembayaranFreelance ? "block" : "none" }}
        className={style.containerPembayaranFreelance}
      >
        <div className={style.judulPembayaranFreelance}>
          Pembayaran Freelance
          <div
            style={{ cursor: "pointer" }}
            onClick={() => KlikSilangPembayaranFreelance()}
          >
            <img src={LogoSilang} />
          </div>
        </div>
        <div className={style.isiPembayaranFreelance}>
          <select
            value={valuePembayaranFreelance}
            onChange={(e) => setValuePembayaranFreelance(e.target.value)}
          >
            <option value="Pilih">Pilih</option>
            <option value="Cash">Cash</option>
            <option value="Non Cash">Non Cash</option>
          </select>
          <div
            style={{
              visibility: visibleKeteranganPembayaranFreelance
                ? "visible"
                : "hidden",
            }}
            className={style.keteranganPembayaranFreelance}
          >
            Pilih pembayaran dahulu
          </div>
          <button
            onClick={() => KlikKirimPembayaranFreelance()}
            className={style.buttonKirimFreelance}
          >
            Kirim
          </button>
        </div>
      </div>
      <div className={style.containerJudul}>
        Attendance Gym
        <div style={{ cursor: "pointer" }} onClick={() => navigate("/gym2")}>
          <img src={LogoGym} />
        </div>
      </div>
      <div className={style.containerIsi}>
        <input
          value={scanRfid}
          onChange={(e) => {
            ScanRfid(e.target.value);
          }}
          ref={inputRef}
          className={style.inputRfid}
        />
        <div className={style.tulisanTap}>
          <div>{berhasilFreelance ? "Hai" : ""}</div>
          <div>
            {berhasilFreelance ? namaSapaan : "Tap your card please :)"}
          </div>
          <div>{berhasilFreelance ? "Keep Healty :)" : ""}</div>
        </div>
      </div>
    </div>
  );
};
export default AttendanceGym2;
